module.exports = __webpack_public_path__ + "img/arrow.47b01178.svg";